module.exports = __webpack_public_path__ + "img/mayor.8bc375d6.jpg";